import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface UserCreds {
  email: string;
  phone: string;
  password: string;
  userType: 'student';
}

interface BasicInfo {
  firstName: string;
  lastName: string;
  grade: string;
  school: string;
  parentid?: number; // Optional, based on API
}

interface StudentState {
  signUpData: UserCreds | null;
  basicInfo: BasicInfo | null;
}

const initialState: StudentState = {
  signUpData: null,
  basicInfo: null,
};

const studentSlice = createSlice({
  name: 'student',
  initialState,
  reducers: {
    updateSignUpData: (state, action: PayloadAction<UserCreds>) => {
      state.signUpData = action.payload;
    },
    updateBasicInfo: (state, action: PayloadAction<BasicInfo>) => {
      state.basicInfo = action.payload;
    },
    clearStudentData: state => {
      state.signUpData = null;
      state.basicInfo = null;
    },
  },
});

export const {updateSignUpData, updateBasicInfo, clearStudentData} =
  studentSlice.actions;
export default studentSlice.reducer;
